import { BagPersonalOffOutlineIcon } from './BagPersonalOffOutlineIcon';

/**
 * author: Michael Richins
 * id 822DE3FA-6BBB-4DF9-B586-A63CA5162EF1
 * name bag-personal-off-outline
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bag-personal-off-outline.svg
 * tags
 * - Transportation + Flying 
 */
export const BackpackOffOutlineIcon = BagPersonalOffOutlineIcon;
export default BackpackOffOutlineIcon